import { render, staticRenderFns } from "./cash_register_set.vue?vue&type=template&id=20731085"
import script from "./cash_register_set.vue?vue&type=script&lang=js"
export * from "./cash_register_set.vue?vue&type=script&lang=js"
import style0 from "./cash_register_set.vue?vue&type=style&index=0&id=20731085&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports